module.exports = __webpack_public_path__ + "img/biter-run-2.ec546df4.png";